import { render } from "./Manufacturers.vue?vue&type=template&id=27c8f7a8&scoped=true"
import script from "./Manufacturers.vue?vue&type=script&lang=js"
export * from "./Manufacturers.vue?vue&type=script&lang=js"

import "./Manufacturers.vue?vue&type=style&index=0&id=27c8f7a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c8f7a8"]])

export default __exports__